import { RootState, ChecklistWithRelations, OutOfTimeRequestStatusState } from './types/state';
import {
  Plan,
  FilterOptions,
  Focus,
  FocusRequirementWithDetails,
  Objective,
  Activity,
} from '@shared/schema';

export function plans(state: RootState): Plan[] {
  return state.plans.plans;
}

export function focusFulfillmentValidations(state: RootState): any[] {
  return state.plans.focusFulfillmentValidations;
}

export function readOnlyMode(state: RootState): boolean | null {
  return state.plans.readOnlyMode;
}

export function creatingOutOfTimePlan(state: RootState): boolean {
  return state.plans.creatingOutOfTimePlan;
}

export function isLoadingChecklistsResponses(state: RootState): boolean {
  return state.checklists.loadingResponses;
}

export function activeOutOfTimeRequestId(state: RootState): number | null {
  return state.plans.activeOutOfTimeRequestId;
}

export function userRoles(state: RootState): string[] {
  return state.plans.userRoles;
}

export function loadingUserRoles(state: RootState): boolean {
  return state.plans.loadingUserRoles;
}

export function outOfTimeRequestStatus(state: RootState): OutOfTimeRequestStatusState | null {
  return state.plans.outOfTimeRequestStatus;
}

export function loadingOutOfTimeRequestStatus(state: RootState): boolean {
  return state.plans.loadingOutOfTimeRequestStatus;
}

export function submittingOutOfTimeRequest(state: RootState): boolean {
  return state.plans.submittingOutOfTimeRequest;
}

export function processingOutOfTimeDecision(state: RootState): boolean {
  return state.plans.processingOutOfTimeDecision;
}

export function processingReopenDecision(state: RootState): boolean {
  return state.plans.processingReopenDecision;
}

export function currentVersion(state: RootState): number | null {
  return state.plans.currentVersion;
}

export function currentPlanId(state: RootState): number | null {
  return state.plans.currentPlanId ?? null;
}

export function currentBusinessUnit(state: RootState): string | null {
  return state.plans.currentBusinessUnit ?? null;
}

export function planRequirementDecisions(state: RootState) {
  return state.plans.planRequirementDecisions;
}

export function selectedHierarchicalModelId(state: RootState): number | null {
  return state.plans.selectedHierarchicalModelId ?? null;
}

export function selectedYear(state: RootState): number | null {
  return state.plans.selectedYear;
}

export function scopeName(state: RootState): string {
  return state.plans.scopeName;
}

export function enterpriseName(state: RootState): string {
  return state.plans.enterpriseName;
}

export function currentFulfillmentVersion(state: RootState): number | null {
  return state.plans.currentFulfillmentVersion;
}

export function filtroOptions(state: RootState): FilterOptions {
  return state.plans.filtroOptions;
}

export function periods(state: RootState) {
  return state.plans.periods;
}

export function filterOptions(state: RootState): FilterOptions {
  return state.plans.filtroOptions;
}

export function isLoadingPlans(state: RootState): boolean {
  return state.plans.loading;
}

export function errorMessagePlans(state: RootState): string | null {
  return state.plans.errorMessage;
}

export function plansPagination(state: RootState) {
  return state.plans.pagination;
}

export function currentPage(state: RootState): number {
  return state.plans.pagination.currentPage;
}

export function totalPages(state: RootState): number {
  return state.plans.pagination.totalPages;
}

export function pageSize(state: RootState): number {
  return state.plans.pagination.itemsPerPage;
}

export function isLoading(state: RootState): boolean {
  return state.plans.loading;
}

export function annualPlans(state: RootState): any {
  return state.annualPlanV2.annualPlans;
}

export function annualPlanExternalData(state: RootState): any {
  return state.annualPlanV2.externalData;
}

export function isLoadingAnnualPlans(state: RootState): boolean {
  return state.annualPlanV2.loading.plans;
}

export function annualPlanV2ErrorMessage(state: RootState): string | null {
  return state.annualPlanV2.errorMessage;
}

export function focuses(state: RootState): Focus[] {
  return state.focuses.focuses;
}

export function isLoadingFocuses(state: RootState): boolean {
  return state.focuses.loading;
}

export function focusesErrorMessage(state: RootState): string | null {
  return state.focuses.errorMessage;
}

export function objectives(state: RootState): Objective[] {
  return state.objectives.objectives;
}

export function isLoadingObjectives(state: RootState): boolean {
  return state.objectives.loading;
}

export function objectivesErrorMessage(state: RootState): string | null {
  return state.objectives.errorMessage;
}

export function requirements(state: RootState): FocusRequirementWithDetails[] {
  return state.requirements.requirements;
}

export function isLoadingRequirements(state: RootState): boolean {
  return state.requirements.loading;
}

export function requirementsErrorMessage(state: RootState): string | null {
  return state.requirements.errorMessage;
}

export function activities(state: RootState): Activity[] {
  return state.activities.activities;
}

export function isLoadingActivities(state: RootState): boolean {
  return state.activities.loading;
}

export function activitiesErrorMessage(state: RootState): string | null {
  return state.activities.errorMessage;
}

export function checklists(state: RootState): ChecklistWithRelations[] {
  return state.checklists.checklists;
}

export function isLoadingChecklists(state: RootState): boolean {
  return state.checklists.loading;
}

export function checklistsErrorMessage(state: RootState): string | null {
  return state.checklists.errorMessage;
}

export function selfAssessmentResults(state: RootState) {
  return state.selfAssessmentResults.data;
}

export function isLoadingSelfAssessmentResults(state: RootState): boolean {
  return state.selfAssessmentResults.loading;
}

export function snack(
  state: RootState,
): { message: string; severity: string; open: boolean } | undefined {
  return state.alert.snack;
}

export function isAnyLoading(state: RootState): boolean {
  return (
    isLoadingPlans(state) ||
    isLoadingAnnualPlans(state) ||
    isLoadingFocuses(state) ||
    isLoadingObjectives(state) ||
    isLoadingRequirements(state) ||
    isLoadingActivities(state) ||
    isLoadingChecklists(state)
  );
}
